import { ConnectionDetails, convertConnectionToDetails, mergeConnectionDetails as merge } from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  LostAndFoundIssueDocument,
  LostAndFoundIssueDocumentSearch,
  SearchLostAndFoundIssueDocumentResponseLostAndFoundIssueDocumentConnectionArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { SearchLostAndFoundIssueDocument } from '../queries/SearchLostAndFoundIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof LostAndFoundIssueDocumentSearch]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<LostAndFoundIssueDocument>>;
}

// SearchLostAndFoundIssueDocument Service
export const { searchLostAndFoundIssueDocument, refetchLostAndFoundIssueDocument, useLostAndFoundIssueDocument } = ((): {
  searchLostAndFoundIssueDocument: ServiceMethod;
  refetchLostAndFoundIssueDocument: ServiceMethod;
  useLostAndFoundIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchLostAndFoundIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<LostAndFoundIssueDocument>> => {
        const args: SearchLostAndFoundIssueDocumentResponseLostAndFoundIssueDocumentConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? 'searchLostAndFoundIssueDocument.lostAndFoundIssueDocumentConnection' : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty('searchLostAndFoundIssueDocument.lostAndFoundIssueDocumentConnection', res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchLostAndFoundIssueDocument: fetch,
    refetchLostAndFoundIssueDocument: refetch,
    useLostAndFoundIssueDocument: useService,
  };
})();
